import {
  SAVE_DEVICE_QUERY,
  GET_DEVICE_SUCCESS,
  FETCH_DEVICE_SUCCESS,
  CREATE_DEVICE_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_DEVICE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_DEVICE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_DEVICE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_DEVICE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
